import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./Components/Global/Navigation/Navigation";
import Footer from "./Components/Global/Footer/Footer";
import Home from "./Components/Home/Home";
import FindBank from "./Components/FindBank/FindBank";
import AboutUs from "./Components/AboutUs/AboutUs";
import Shop from "./Components/Shop/Shop";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/banks" element={<FindBank />} />
          <Route exact path="/aboutUs" element={<AboutUs />} />
          <Route exact path="/shop" element={<Shop />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
